import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import { ConfirmationDialog } from "../ConfirmationDialog";

import styles from "./LeavePageConfirmationDialog.module.scss";

export type LeavePageConfirmationDialogProps = {
  isOpened: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  portalDomNode?: HTMLElement;
};

export const LeavePageConfirmationDialog: FC<LeavePageConfirmationDialogProps> = ({
  isOpened,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  portalDomNode,
}) => {
  const { __ } = useTranslations();
  const confirmLabelText = confirmLabel || __("libs.ui.leave_page_confirmation_dialog.leave_button_label");
  const cancelLabelText = cancelLabel || __("libs.ui.leave_page_confirmation_dialog.stay_button_label");

  const subTitle = (
    <div className={styles.content}>
      <div>{__("libs.ui.leave_page_confirmation_dialog.sub_title")}</div>
      <div>{__("libs.ui.leave_page_confirmation_dialog.confirm_text")}</div>
    </div>
  );

  return (
    <ConfirmationDialog
      isOpened={isOpened}
      title={__("libs.ui.leave_page_confirmation_dialog.title")}
      subTitle={subTitle}
      confirmButtonText={confirmLabelText}
      cancelButtonText={cancelLabelText}
      onConfirm={onConfirm}
      onCancel={onCancel}
      portalDomNode={portalDomNode}
    />
  );
};
